module.exports = __webpack_public_path__ + "static/turquia-016.thumb-97fd150a1232165e9a8c66d9445fd514.jpg";